import JSEncrypt from 'jsencrypt';

const isMobile = /^[1]([3-9])[0-9]{9}$/;
const isCode = /\d{6}/;
const isPwd = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/; // 密码格式验证 6-20位字母、数字和符号任意组合

/**
 * 是否是手机号
 * @param {String} mobile
 */
export function isMobilePhone(mobile) {
  return isMobile.test(mobile);
}

/**
 * 校验用户名
 * @param {String} name
 */
export function unValidName(name) {
  if (!name) {
    return '账号不得为空';
  }
  if (name.length < 4) {
    return '用户账号必须大于4位';
  }
  return '';
}

/**
 * 校验密码
 * @param {String} pwd
 */
export function unValidPwd(pwd) {
  if (!pwd) {
    return '密码不得为空';
  }
  if (!isPwd.test(pwd)) {
    return '密码由6-20位字母、数字和符号组成';
  }
  return '';
}

/**
 * 校验密码不为空
 * @param {String} pwd
 */
export function unValidPwd2(pwd) {
  if (!pwd) {
    return '密码不得为空';
  }
  return '';
}

/**
 * 校验手机号
 * @param {String} mobile
 */
export function unValidMoblie(mobile) {
  if (!mobile) {
    return '手机号码不得为空';
  }
  if (!isMobile.test(mobile)) {
    return '请填写正确的手机号';
  }
  return '';
}

/**
 * 校验验证码
 * @param {String} code
 */
export function unValidCode(code) {
  if (!code) {
    return '验证码不能为空';
  }
  if (!isCode.test(code)) {
    return '请填写正确的验证码';
  }
  return '';
}

/**
 * 校验图片验证码
 * @param {String} captcha
 */
export function unValidImgCaptcha(captcha) {
  if (!captcha) {
    return '请填写图形验证码';
  }
  if (captcha.length !== 5) {
    return '请填写正确的图形验证码';
  }
  return '';
}

/**
 * 校验账号信息
 * @param {String} name
 */
export function unValidUserAccount(name) {
  if (!name) {
    return '请选择账号';
  }
  return '';
}

/**
 * 校验是否勾选
 * @param {Number} isCheck
 */
export function unValidAgreement(isCheck) {
  if (!isCheck) {
    return '请阅读并勾选协议';
  }
  return '';
}

/**
 * 密码强度检测
 * @param {String} pwd
 */
export function checkIntensity(pwd) {
  if (!pwd) {
    return '';
  }
  let m = 0;
  let Modes = 0;
  // 十进制 、二进制互换
  for (let i = 0; i < pwd.length; i += 1) { // 测试每一个字符的类别并统计一共有多少种模式
    let charType = 0;
    const t = pwd.charCodeAt(i); // charCodeAt() 方法返回指定位置的字符的 Unicode 编码
    // 判断输入密码的类型
    if (t >= 48 && t <= 57) {
      charType = 1;
    } else if (t >= 65 && t <= 90) {
      charType = 2;
    } else if (t >= 97 && t <= 122) {
      charType = 3;
    } else {
      charType = 4;
    }
    // 密码模式 按位或运算 二进制上下比较只有位值都为0时才取0，否则取1
    Modes |= charType; // eslint-disable-line
  }
  // 计算密码模式
  for (let i = 0; i < 4; i += 1) {
    if (Modes & 1) { // eslint-disable-line
      m += 1;
    }
    // 按位与运算 两二进制上下比较只有位值都为1时才取1，否则取0
    // Modes 二进制向右移1位 再装换成十进制
    Modes >>>= 1; // eslint-disable-line
  }
  if (pwd.length <= 5) {
    m = 1;
  }
  if (pwd.length <= 0) {
    m = 0;
  }
  if (m === 2) {
    return '安全强度适中，可使用3种及以上组合提高安全性！';
  }
  return '';
}

/**
 * RSA加密
 * @param {String} str
 * @returns {String}
 */
export function cmdRSAEncrypt(str) {
  const key = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCPw4bJpPWz0EMS0HkgABrq6ngMrHOfsWhRcKD6PKpUEzrqb22kDR67ODNxu14Q286IgEUYs7RZjVs9MaEEIRk9Q/QC1yzfZVwRmcwN3HSIlhKR7gh/UZx/bwU0ZYoCuc6RrGUWYwo0kGs1GovJjbyduLgNr8incqKmN0Tnj1C0BQIDAQAB';
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(key);
  return encrypt.encrypt(str);
}
